<template>
  <div class="col-12" v-if="objSelected != null">
    <p class="text-center">
      <span>
        <div v-if="objSelected.operatorUrl != null">
          <img :src="objSelected.operatorUrl" class="circle-image" />
        </div>
        <div v-else>
          <img
            src="../../../public/images/sespa/user.png"
            class="circle-image"
          />
        </div>
      </span>

      <br />
      <strong v-if="objSelected">{{ objSelected.operator }}.</strong>
    </p>
  </div>
</template>

<script>
export default {
  props: ["objSelected"],
};
</script>

<style></style>
